<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold my-5">{{ form.getFieldValue('breakDown') === 'matter' ? item.matter : item.client }}</div>
            <div v-for="(account,index) in Object.values(item.bank_accounts)" :key="index">
              <div class="font-semibold my-5">{{ account.name }}</div>
              <a-table :dataSource="account.transactions" :columns="columns" :pagination="false"  class="tbl-receivable">
                <template slot="description" slot-scope="text,record">
                  {{ limitTextTask(record.description) }}
                </template>
                <template slot="date" slot-scope="text,record">
                  {{ setDateFormat(record.created_at) }}
                </template>
                <template slot="flag" slot-scope="text,record">
                  <a href="#" @click="goToDashboardBill(record.bill)">{{ record.flag }}</a>
                </template>
                <template slot="footer">
                  <template v-if="form.getFieldValue('showSummery')">
                    <template v-if="account.transactions.length">
                      <div class="grid grid-cols-2">
                        <div class="font-bold">Total:</div>
                        <div class="">{{ currencySymbol + sumCol(account.transactions,'amount') }}</div>
                      </div>
                    </template>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <a-form-item>
          <a-checkbox v-decorator="['showSummery',{ rules: [{ required: false, message: 'this field is required.' }] }]">Display Bank Account Summary</a-checkbox>
        </a-form-item>
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-end w-full md:w-1/2"
              :is_include_matter="false"
              @selectSearch="handleSearch"
              placeholder="Enter Name Of Client"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <a-form-item label="Break down level detail">
            <a-select v-decorator="['breakDown',{ rules: [{ required: false, message: 'this field is required.' }] }]">
              <a-select-option value="client">
                Client
              </a-select-option>
              <a-select-option value="matter">
                Matter
              </a-select-option>
            </a-select>
          </a-form-item>
          <DateRangeComponent class="mt-4" :dateForm="form" />
          <a-form-item>
            <a-checkbox-group
              v-decorator="['groupCheckedValue',{ rules: [{ required: false, message: 'this field is required.' }] }]"
              :options="options"
              class="flex flex-col gap-y-4 mt-5 select-none"
            />
          </a-form-item>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit(url === 'contact/report/ledger' ? 'changeTab' : 'componentLedgerBack' ,'ClientReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const options = [
  { label: 'Include Opening Balance', value: 'l_open' },
  { label: 'Display Matter to Matter Transfer Transactions', value: 'l_matter' },
  { label: 'Show clients with zero balance', value: 'l_zero' },
];

const columns = [
  {
    title: 'Inv No',
    dataIndex: 'flag',
    key: '0',
    scopedSlots: { customRender: 'flag' },
  },
  {
    title: 'Date',
    dataIndex: 'created_at',
    key: '1',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'Matter',
    dataIndex: 'matter',
    key: '2',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '3',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: '4',
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: '5',
  },
]

export default {
  name: "ComponentClientLedger",
  props: {
    title: {
      type: String,
      default: 'Client Ledger'
    },
    url: {
      type: String,
      default: 'contact/report/ledger'
    }
  },
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      checked_matter_client: null,
      options,
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },

  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },

  methods:{
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if(values.breakDown === 'matter') {
              const checked = values.groupCheckedValue === undefined ? [] : values.groupCheckedValue
              values.groupCheckedValue = [...checked,'breakdown_matter']
            }
            if (values.contact) query.push({ field:'id', condition: '=', value: values.contact, operation: 'and' })
            if (values.practice_area) query.push({ field:'client_matters__practice_area', condition: '=', value: values.practice_area, operation: 'and' })
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data}    = await axios.post(this.url,{
              query: query.length ? query : undefined,
              options: values.groupCheckedValue && values.groupCheckedValue.length ? values.groupCheckedValue : [],
            })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    hasDownloaded(e) {
      console.log(e,'eeee')
    },
    goToDashboardBill(id) {
      if (id)
        this.$router.push(`/billing/dashboard/${id}`)
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
